import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService, setupManagementUrl, userManagementUrl } from "../../../../config";
import { allLeaveTypes, allUsers } from "../../../../data/Queries/HRmanagement/leavemanagement";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { leavePolicyFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { fetchJson } from "../../../../data/DynamicServiceNew/jsondynamicservice";
const base_url = HRService.uri;

const DisbursementTypesForm = (props) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    type: props.data ? props.data.Type : "",
  
  };




  const fields = [
    {
      name: "type",
      label: "Disbursment Type",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
     
      const mutationData = {
          type: values.type,
      };
       if (props.isEditing) {
        mutationData.id = props.data.Id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing
        ?"updateDisbursementTypes" : "createDisbursementTypes",
        mutationData,
        "functionParams",
        base_url
      );
      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Disbursement Type ${props.isEditing ? "updated" : "added"} successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title="Disbursement Types"
      subtitle="Create Disbursement Type."
    />
  );
};

export default DisbursementTypesForm;
